import { authFetch } from '@/services/apiClient'

interface ApiResponse<T> {
  success: boolean
  data?: T
  error?: string
  message?: string
}

export interface CertificateResult {
  certificate_id: number
  enrollment_id: number
  certificate_number: string
  issued_at: string
  expires_at: string | null
  holder_name: string
  course_title: string
  duration_minutes: number   // ผลรวมนาทีของทุกบทเรียน — ใช้แสดง "ระยะเวลารวม" บนใบประกาศ
  instructor: {
    first_name: string
    last_name: string
    signature_url: string | null
  } | null
}

async function parseJson<T>(res: Response): Promise<ApiResponse<T>> {
  try {
    return await res.json()
  } catch {
    return { success: false, error: 'เชื่อมต่อเซิร์ฟเวอร์ไม่สำเร็จ' }
  }
}

export const getMyCertificates = async (): Promise<CertificateResult[]> => {
  const res = await authFetch('/my-certificates')
  const json = await parseJson<CertificateResult[]>(res)
  if (!json.success || !json.data) throw new Error(json.error || json.message || 'โหลดใบประกาศไม่สำเร็จ')
  return json.data
}

export const getCertificateByEnrollment = async (enrollmentId: number | string): Promise<CertificateResult> => {
  const res = await authFetch(`/enrollments/${enrollmentId}/certificate`)
  const json = await parseJson<CertificateResult>(res)
  if (!json.success || !json.data) throw new Error(json.error || json.message || 'ไม่พบใบประกาศ')
  return json.data
}
